const PRIMARY_COLOR = "#3300FF";
const PRICE_GREEN_COLOR = "green";

module.exports = {
  PRIMARY_COLOR,
  PRICE_GREEN_COLOR
};
